"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const models_1 = require("@completeanatomy/models");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../../hooks");
const ModelDownloadingProgress_1 = __importDefault(require("../../molecules/ModelDownloadingProgress"));
function ModelDownloadingOverlay() {
    const modelID = (0, hooks_1.useDownloadingModelId)();
    const progress = (0, hooks_1.useDownloadingModelProgress)(modelID);
    const model = (0, models_1.useModel)(modelID);
    const bridge = (0, bridge_1.useBridge)();
    const onCancel = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.cancelODRModelDownload();
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'ModelDownloadingOverlay_Container', children: [(0, jsx_runtime_1.jsx)(ModelDownloadingProgress_1.default, { progress: progress, modelName: (model === null || model === void 0 ? void 0 : model.name) || '', "data-e2e": 'ModelDownloadingOverlay_ModelDownloadingProgress' }), (0, jsx_runtime_1.jsx)(CancelButton, { onClick: onCancel, "data-e2e": 'ModelDownloadingOverlay_CancelButton', children: (0, i18n_1.Localized)(i18n_1.Strings.common.cancel) })] }));
}
exports.default = ModelDownloadingOverlay;
const Container = styled_components_1.default.div `
  background-color: ${props => props.theme.black};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;
const CancelButton = (0, styled_components_1.default)(ui_1.BaseButton) `
  padding: 0;
  position: absolute;
  background-color: transparent;
  color: ${({ theme }) => theme.white_50};
  left: 28px;
  bottom: 24px;
`;
